<template>
  <base-dialog v-model="isVisible">
    <dialog-template style="max-width: 720px;" mobile-stretch>
      <div
        slot="title"
        :class="$style.header"
      >
        <h3
          :class="$style.title"
          v-text="$t('report.datepicker.title')"
        ></h3>
        <datepicker-toolbar
          v-model="range"
          @change="handleChangeDatepicker"
          @show-presets="handleShownPresets"
        />
      </div>

      <template slot="content">
        <responsive-controller>
          <template #tablet>
            <datepicker-scroller
              v-model="range"
              :show-calendar="false"
              range
            />
          </template>
          <template #default>
            <datepicker-calendar
              v-model="range"
              :show-calendar="false"
              range
            />
          </template>
        </responsive-controller>
      </template>

      <div slot="footer" :class="$style.footer">
        <simple-button
          variant="primary"
          @click="handleSelect"
        >
          {{ $t('common.save') }}
        </simple-button>

        <simple-button
          variant="transparent"
          @click="isVisible = false"
        >
          {{ $t('common.cancel') }}
        </simple-button>
      </div>
    </dialog-template>
  </base-dialog>
</template>

<script>
import { isMobileOnly } from 'mobile-device-detect';

import BaseDialog from 'molecules/base/Dialog';
import SimpleButton from 'molecules/common/SimpleButton';
import DatepickerScroller from 'molecules/datetime/DatepickerScroller';
import DatepickerCalendar from 'molecules/datetime/DatepickerCalendar';
import DatepickerToolbar from 'molecules/datetime/DatepickerToolbar';
import DialogTemplate from 'templates/DialogTemplate';

import { EVENT_BUS } from '@/eventBus';

import { getMomentConstructor } from 'lib/utils/date';

const moment = getMomentConstructor();

export default {
  name: 'SelectingDateRange',
  components: {
    BaseDialog,
    SimpleButton,
    DatepickerScroller,
    DatepickerCalendar,
    DatepickerToolbar,
    DialogTemplate,
  },
  created() {
    EVENT_BUS.$on('SELECTING_DATE_RANGE', data => {
      this.range = {
        from: moment(data.dateFrom),
        to: moment(data.dateTo),
      };

      this.isVisible = true;
    });
  },
  data() {
    return {
      range: {
        from: null,
        to: null,
      },
      isVisible: false,
      isMobile: isMobileOnly,
    };
  },
  computed: {
    dateRange() {
      return {
        dateFrom: this.range.from,
        dateTo: this.range.to,
      };
    },
  },
  methods: {
    handleSelect() {
      EVENT_BUS.$emit('SELECTED_DATE_RANGE', this.dateRange);

      this.isVisible = false;
    },
    handleShownPresets() {
      EVENT_BUS.$emit('SELECTING_PERIOD_PRESET', this.dateRange);

      this.isVisible = false;
    },
    handleChangeDatepicker(value) {
      this.range = value;
    },
  },
};
</script>

<style lang="sass" module>
  .header
    +flexbox
    +flex-direction(column)

    +respond-to('small')
      +flex-direction(row)
      +align-items(center)
      +justify-content(space-between)

  .title
    +font-type('semi-bold', 20, 24)
    margin: 0 0 10px

    +respond-to('small')
      margin: 0 10px 0 0

  .footer
    +flexbox
    +flex-direction(column)

    +respond-to('small')
      +flex-direction(row)
      +justify-content(center)
      width: 80%
      margin: 0 auto

    button
      &:nth-child(1)
        margin: 0 0 10px

      +respond-to('small')
        &:nth-child(1)
          margin: 0 10px 0 0
</style>
